import { createFileRoute } from '@tanstack/react-router'
import { ForgotPasswordPage } from '~/features/auth/PasswordPages'

export const Route = createFileRoute('/passwort-vergessen')({
  component: ForgotPasswordPage,
})
